document.addEventListener('DOMContentLoaded', () => {
  // buttonからの送信
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    '[data-ai-chat-button]'
  );
  if (buttons.length > 0) {
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        window.dispatchEvent(
          new CustomEvent('call-chatbot', {
            detail: {
              text: button.innerText,
            },
          })
        );
      });
    });
  }

  // inputからの送信
  const input = document.querySelector<HTMLInputElement>(
    '[data-ai-chat-input]'
  );
  if (input) {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && !e.isComposing && input.value.trim()) {
        window.dispatchEvent(
          new CustomEvent('call-chatbot', {
            detail: {
              text: input.value.trim(),
            },
          })
        );
        input.value = '';
      }
    });
  }

  // Enterボタンからの送信
  const enterButton = document.querySelector<HTMLButtonElement>(
    '[data-ai-chat-enter]'
  );
  if (enterButton && input) {
    enterButton.addEventListener('click', () => {
      const text = input.value.trim();
      if (!text) return;
      window.dispatchEvent(
        new CustomEvent('call-chatbot', {
          detail: {
            text,
          },
        })
      );
      input.value = '';
    });
  }
});
